import artifact from '$houdini/artifacts/UpdateVendor'
import { MutationStore } from '../runtime/stores/mutation'

export class UpdateVendorStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
